var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphlineblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09525 14.6666V16.5524C2.09525 17.7257 2.09525 18.3124 2.31094 18.7607C2.50065 19.155 2.80336 19.4755 3.17569 19.6764C3.59817 19.9047 4.15225 19.9047 5.25841 19.9047H19.9048M2.09525 14.6666V2.09521M2.09525 14.6666L5.91143 11.3006C7.52814 9.87379 8.59077 10.0205 9.98684 11.4986L9.99278 11.5049C11.5145 13.1162 12.6048 13.0491 14.1206 11.6443L19.9048 6.28569",
    stroke: "#8276F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphlineblue);
export default __webpack_public_path__ + "static/media/graphlineblue.aa1ed5e1bf3b0c0f1b9d668a524b0d72.svg";
export { ForwardRef as ReactComponent };